import {
    TAXONOMIAS_LOADING,
    TAXONOMIAS_LOADED,
    TAXONOMIAS_ERROR,

    REINO_LOADING,
    REINO_LOADED,
    REINO_ERROR,
    CREAREINO_ERROR,
    CREAREINO_LOADED,
    CREAREINO_LOADING,
    EDITAREINO_ERROR,
    EDITAREINO_LOADED,
    EDITAREINO_LOADING,
    DELETEREINO_ERROR,
    DELETEREINO_LOADED,
    DELETEREINO_LOADING,

    FILO_LOADING,
    FILO_LOADED,
    FILO_ERROR,
    CREARFILO_ERROR,
    CREARFILO_LOADED,
    CREARFILO_LOADING,
    EDITARFILO_ERROR,
    EDITARFILO_LOADED,
    EDITARFILO_LOADING,
    DELETEFILO_ERROR,
    DELETEFILO_LOADED,
    DELETEFILO_LOADING,

    SUBFILO_LOADING,
    SUBFILO_LOADED,
    SUBFILO_ERROR,
    CREARSUBFILO_ERROR,
    CREARSUBFILO_LOADED,
    CREARSUBFILO_LOADING,
    EDITARSUBFILO_ERROR,
    EDITARSUBFILO_LOADED,
    EDITARSUBFILO_LOADING,
    DELETESUBFILO_ERROR,
    DELETESUBFILO_LOADED,
    DELETESUBFILO_LOADING,

    CLASE_LOADING,
    CLASE_LOADED,
    CLASE_ERROR,
    CREARCLASE_ERROR,
    CREARCLASE_LOADED,
    CREARCLASE_LOADING,
    EDITARCLASE_ERROR,
    EDITARCLASE_LOADED,
    EDITARCLASE_LOADING,
    DELETECLASE_ERROR,
    DELETECLASE_LOADED,
    DELETECLASE_LOADING,

    INFRACLASE_LOADING,
    INFRACLASE_LOADED,
    INFRACLASE_ERROR,
    CREARINFRACLASE_ERROR,
    CREARINFRACLASE_LOADED,
    CREARINFRACLASE_LOADING,
    EDITARINFRACLASE_ERROR,
    EDITARINFRACLASE_LOADED,
    EDITARINFRACLASE_LOADING,
    DELETEINFRACLASE_ERROR,
    DELETEINFRACLASE_LOADED,
    DELETEINFRACLASE_LOADING,

    ORDEN_LOADING,
    ORDEN_LOADED,
    ORDEN_ERROR,
    CREARORDEN_ERROR,
    CREARORDEN_LOADED,
    CREARORDEN_LOADING,
    EDITARORDEN_ERROR,
    EDITARORDEN_LOADED,
    EDITARORDEN_LOADING,
    DELETEORDEN_ERROR,
    DELETEORDEN_LOADED,
    DELETEORDEN_LOADING,

    SUBORDEN_LOADING,
    SUBORDEN_LOADED,
    SUBORDEN_ERROR,
    CREARSUBORDEN_ERROR,
    CREARSUBORDEN_LOADED,
    CREARSUBORDEN_LOADING,
    EDITARSUBORDEN_ERROR,
    EDITARSUBORDEN_LOADED,
    EDITARSUBORDEN_LOADING,
    DELETESUBORDEN_ERROR,
    DELETESUBORDEN_LOADED,
    DELETESUBORDEN_LOADING,

    FAMILIA_LOADING,
    FAMILIA_LOADED,
    FAMILIA_ERROR,
    CREARFAMILIA_ERROR,
    CREARFAMILIA_LOADED,
    CREARFAMILIA_LOADING,
    EDITARFAMILIA_ERROR,
    EDITARFAMILIA_LOADED,
    EDITARFAMILIA_LOADING,
    DELETEFAMILIA_ERROR,
    DELETEFAMILIA_LOADED,
    DELETEFAMILIA_LOADING,

    SUBFAMILIA_LOADING,
    SUBFAMILIA_LOADED,
    SUBFAMILIA_ERROR,
    CREARSUBFAMILIA_ERROR,
    CREARSUBFAMILIA_LOADED,
    CREARSUBFAMILIA_LOADING,
    EDITARSUBFAMILIA_ERROR,
    EDITARSUBFAMILIA_LOADED,
    EDITARSUBFAMILIA_LOADING,
    DELETESUBFAMILIA_ERROR,
    DELETESUBFAMILIA_LOADED,
    DELETESUBFAMILIA_LOADING,

    TRIBU_LOADING,
    TRIBU_LOADED,
    TRIBU_ERROR,
    CREARTRIBU_ERROR,
    CREARTRIBU_LOADED,
    CREARTRIBU_LOADING,
    EDITARTRIBU_ERROR,
    EDITARTRIBU_LOADED,
    EDITARTRIBU_LOADING,
    DELETETRIBU_ERROR,
    DELETETRIBU_LOADED,
    DELETETRIBU_LOADING,

    GENERO_LOADING,
    GENERO_LOADED,
    GENERO_ERROR,
    CREARGENERO_ERROR,
    CREARGENERO_LOADED,
    CREARGENERO_LOADING,
    EDITARGENERO_ERROR,
    EDITARGENERO_LOADED,
    EDITARGENERO_LOADING,
    DELETEGENERO_ERROR,
    DELETEGENERO_LOADED,
    DELETEGENERO_LOADING,

    ESPECIE_LOADING,
    ESPECIE_LOADED,
    ESPECIE_ERROR,
    CREARESPECIE_ERROR,
    CREARESPECIE_LOADED,
    CREARESPECIE_LOADING,
    EDITARESPECIE_ERROR,
    EDITARESPECIE_LOADED,
    EDITARESPECIE_LOADING,
    DELETESPECIE_ERROR,
    DELETESPECIE_LOADED,
    DELETESPECIE_LOADING,

    TAXA_LEVEL_LOADED,
    TAXA_LEVEL_LOADING,
    TAXA_LEVEL_ERROR,

    CREAR_TAXONOMIA_LOADING,
    CREAR_TAXONOMIA_SUCCESS,
    CREAR_TAXONOMIA_ERROR,

    VER_INDI_USER_TAXA_LOADING,
    VER_INDI_USER_TAXA_LOADED,
    VER_INDI_USER_TAXA_ERROR,
    
    TAXA_EDIT_LOADED,
    TAXA_EDIT_LOADING,
    TAXA_EDIT_ERROR,
    TAXA_EDIT_RESET,
  } from './../../types/taxonomiatypes';

const INITIAL_STATE = {
    taxonomias:[],
    taxalevel: [],
    taxouser: null,
    isLoaded:false,
    isLoading: false,
    error: null,
    reino: null,
    creareino: null,
    filo: null,
    crearfilo: null,
    subfilo: null,
    crearsubfilo: null,
    clase: null,
    crearclase: null,
    infraclase: null,
    crearinfraclase: null,
    orden: null,
    crearorden: null,
    suborden: null,
    crearsuborden: null,
    familia: null,
    crearfamilia: null,
    subfamilia: null,
    crearsubfamilia: null,
    tribu: null,
    creartribu: null,
    genero: null,
    creargenero: null,
    especie: null,
    crearespecie: null,

    taxaeditada: null,
    editando:false,
    edicionCompleta:false,

    creando: false, // Estado específico para la creación
    creacionCompleta: false, // Estado específico para el éxito de la creación
    creacionError: null, // Estado específico para el error de la creación
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type){
        case TAXA_EDIT_LOADING:
            return {
                ...state,
                editando:true,
                edicionCompleta:false,
                creacionError: null,
            };
        case TAXA_EDIT_LOADED:
            return {
                ...state,
                editando:false,
                edicionCompleta:true,
                taxaeditada: action.payload,
            };
        case TAXA_EDIT_ERROR:
            return {
                ...state,
                editando:false,
                edicionCompleta:false,
                creacionError: action.payload,
            };
        case TAXA_EDIT_RESET: 
            return {
                ...state,
                edicionCompleta:false,
                creacionError: null,
            };
        case VER_INDI_USER_TAXA_LOADING:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case VER_INDI_USER_TAXA_LOADED:
            return {
                ...state,
                taxouser: action.payload,
                loading: false,
                error: null,
            };
        case VER_INDI_USER_TAXA_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        case CREAR_TAXONOMIA_LOADING:
            return {
                ...state,
                creando: true,
                creacionCompleta: false,
                creacionError: null,
            };
        case CREAR_TAXONOMIA_SUCCESS:
            return {
                ...state,
                creando: false,
                creacionCompleta: true,
            };
        case CREAR_TAXONOMIA_ERROR:
            return {
                ...state,
                creando: false,
                creacionCompleta: false,
                creacionError: action.payload,
            };
        case TAXA_LEVEL_LOADING:
            return {
                ...state,
                loading: true,
                taxalevel: [],
                error: null,
            };
        case TAXA_LEVEL_LOADED:
            return {
                ...state,
                taxalevel: action.payload.results,
                loading: false,
                error: null,
            };
        case TAXA_LEVEL_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
/*-----------------------------Reino-----------------------------------*/
        case TAXONOMIAS_LOADING:
            return {
                ... state,
                isLoading : true,
                taxonomias : [],
                error: ''
            }
        case TAXONOMIAS_LOADED:
            return {
                ...state,
                isLoading : false,
                taxonomias: action.payload,
                isLoaded : true,
                error: ''
            };
        case TAXONOMIAS_ERROR:
            return {
                ...state,
                error: action.payload,
                taxonomias : [],
                isLoading : false,
            }

        case REINO_LOADING:
            return {
                ... state,
                isLoading : true,
                reino : null,
                error: ''
            }
        case REINO_LOADED:
            return {
                ...state,
                isLoading : false,
                reino: action.payload,
                error: ''
            };
        case REINO_ERROR:
            return {
                ...state,
                error: action.payload,
                reino : null,
                isLoading : false,
            }
        case CREAREINO_LOADING:
            return {
                ... state,
                isLoading : true,
                creareino : null,
                error: ''
            }
        case CREAREINO_LOADED:
            return {
                ... state,
                isLoading : false,
                creareino: action.payload,
                error: ''
            };
        case CREAREINO_ERROR:
            return {
                ...state,
                creareino : null,
                isLoading : false,
                error: action.payload,
            }
        case EDITAREINO_LOADING:
            return {
                ... state,
                isLoading : true,
                creareino: null,
                error: ''
            }
        case EDITAREINO_LOADED:
            return {
                ... state,
                isLoading : false,
                creareino: action.payload,
                error: ''
            };
        case EDITAREINO_ERROR:
            return {
                ...state,
                creareino: null,
                isLoading : false,
                error: action.payload,
            }            
        case DELETEREINO_LOADED:
            return { 
                ...state, 
                creareino: action.payload,
                isLoading: false,
                error: ''
            }
        case DELETEREINO_LOADING:
            return { 
                ...state, 
                creareino: null,
                isLoading: true,
                error: ''
            }
        case DELETEREINO_ERROR:
            return { 
                ...state, 
                creareino: null,
                isLoading: false,
                error: action.payload
            }
/*-----------------------------Filo-----------------------------------*/
        case FILO_LOADING:
            return {
                ... state,
                isLoading : true,
                filo : null,
                error: ''
            }
        case FILO_LOADED:
            return {
                ...state,
                isLoading : false,
                filo: action.payload,
                error: ''
            };
        case FILO_ERROR:
            return {
                ...state,
                error: action.payload,
                filo : null,
                isLoading : false,
            }
        case CREARFILO_LOADING:
            return {
                ... state,
                isLoading : true,
                crearfilo : null,
                error: ''
            }
        case CREARFILO_LOADED:
            return {
                ... state,
                isLoading : false,
                crearfilo: action.payload,
                error: ''
            };
        case CREARFILO_ERROR:
            return {
                ...state,
                crearfilo : null,
                isLoading : false,
                error: action.payload,
            }
        case EDITARFILO_LOADING:
            return {
                ... state,
                isLoading : true,
                crearfilo: null,
                error: ''
            }
        case EDITARFILO_LOADED:
            return {
                ... state,
                isLoading : false,
                crearfilo: action.payload,
                error: ''
            };
        case EDITARFILO_ERROR:
            return {
                ...state,
                crearfilo: null,
                isLoading : false,
                error: action.payload,
            }            
        case DELETEFILO_LOADED:
            return { 
                ...state, 
                crearfilo: action.payload,
                isLoading: false,
                error: ''
            }
        case DELETEFILO_LOADING:
            return { 
                ...state, 
                crearfilo: null,
                isLoading: true,
                error: ''
            }
        case DELETEFILO_ERROR:
            return { 
                ...state, 
                crearfilo: null,
                isLoading: false,
                error: action.payload
            }
/*-----------------------------Sub Filo-----------------------------------*/
        case SUBFILO_LOADING:
            return {
                ... state,
                isLoading : true,
                subfilo: null,
                error: ''
            }
        case SUBFILO_LOADED:
            return {
                ...state,
                isLoading : false,
                subfilo: action.payload,
                error: ''
            };
        case SUBFILO_ERROR:
            return {
                ...state,
                error: action.payload,
                subfilo: null,
                isLoading : false,
            }
        case CREARSUBFILO_LOADING:
            return {
                ... state,
                isLoading : true,
                crearsubfilo : null,
                error: ''
            }
        case CREARSUBFILO_LOADED:
            return {
                ... state,
                isLoading : false,
                crearsubfilo: action.payload,
                error: ''
            };
        case CREARSUBFILO_ERROR:
            return {
                ...state,
                crearsubfilo : null,
                isLoading : false,
                error: action.payload,
            }
        case EDITARSUBFILO_LOADING:
            return {
                ... state,
                isLoading : true,
                crearsubfilo: null,
                error: ''
            }
        case EDITARSUBFILO_LOADED:
            return {
                ... state,
                isLoading : false,
                crearsubfilo: action.payload,
                error: ''
            };
        case EDITARSUBFILO_ERROR:
            return {
                ...state,
                crearsubfilo: null,
                isLoading : false,
                error: action.payload,
            }            
        case DELETESUBFILO_LOADED:
            return { 
                ...state, 
                crearsubfilo: action.payload,
                isLoading: false,
                error: ''
            }
        case DELETESUBFILO_LOADING:
            return { 
                ...state, 
                crearsubfilo: null,
                isLoading: true,
                error: ''
            }
        case DELETESUBFILO_ERROR:
            return { 
                ...state, 
                crearsubfilo: null,
                isLoading: false,
                error: action.payload
            }
/*-----------------------------Clase-----------------------------------*/
        case CLASE_LOADING:
            return {
                ... state,
                isLoading : true,
                clase: null,
                error: ''
            }
        case CLASE_LOADED:
            return {
                ...state,
                isLoading : false,
                clase: action.payload,
                error: ''
            };
        case CLASE_ERROR:
            return {
                ...state,
                isLoading : false,
                clase: null,
                error: action.payload,
            }
        case CREARCLASE_LOADING:
            return {
                ... state,
                isLoading : true,
                crearclase : null,
                error: ''
            }
        case CREARCLASE_LOADED:
            return {
                ... state,
                isLoading : false,
                crearclase: action.payload,
                error: ''
            };
        case CREARCLASE_ERROR:
            return {
                ...state,
                crearclase : null,
                isLoading : false,
                error: action.payload,
            }
        case EDITARCLASE_LOADING:
            return {
                ... state,
                isLoading : true,
                crearclase: null,
                error: ''
            }
        case EDITARCLASE_LOADED:
            return {
                ... state,
                isLoading : false,
                crearclase: action.payload,
                error: ''
            };
        case EDITARCLASE_ERROR:
            return {
                ...state,
                crearclase: null,
                isLoading : false,
                error: action.payload,
            }            
        case DELETECLASE_LOADED:
            return { 
                ...state, 
                crearclase: action.payload,
                isLoading: false,
                error: ''
            }
        case DELETECLASE_LOADING:
            return { 
                ...state, 
                crearclase: null,
                isLoading: true,
                error: ''
            }
        case DELETECLASE_ERROR:
            return { 
                ...state, 
                crearclase: null,
                isLoading: false,
                error: action.payload
            }
/*-----------------------------Infra Clase-----------------------------------*/
        case INFRACLASE_LOADING:
            return {
                ... state,
                isLoading : true,
                infraclase: null,
                error: ''
            }
        case INFRACLASE_LOADED:
            return {
                ...state,
                isLoading : false,
                infraclase: action.payload,
                error: ''
            };
        case INFRACLASE_ERROR:
            return {
                ...state,
                error: action.payload,
                isLoading : false,
                infraclase: null,
            }
        case CREARINFRACLASE_LOADING:
            return {
                ... state,
                isLoading : true,
                crearinfraclase : null,
                error: ''
            }
        case CREARINFRACLASE_LOADED:
            return {
                ... state,
                isLoading : false,
                crearinfraclase: action.payload,
                error: ''
            };
        case CREARINFRACLASE_ERROR:
            return {
                ...state,
                crearinfraclase : null,
                isLoading : false,
                error: action.payload,
            }
        case EDITARINFRACLASE_LOADING:
            return {
                ... state,
                isLoading : true,
                crearinfraclase: null,
                error: ''
            }
        case EDITARINFRACLASE_LOADED:
            return {
                ... state,
                isLoading : false,
                crearinfraclase: action.payload,
                error: ''
            };
        case EDITARINFRACLASE_ERROR:
            return {
                ...state,
                crearinfraclase: null,
                isLoading : false,
                error: action.payload,
            }            
        case DELETEINFRACLASE_LOADED:
            return { 
                ...state, 
                crearinfraclase: action.payload,
                isLoading: false,
                error: ''
            }
        case DELETEINFRACLASE_LOADING:
            return { 
                ...state, 
                crearinfraclase: null,
                isLoading: true,
                error: ''
            }
        case DELETEINFRACLASE_ERROR:
            return { 
                ...state, 
                crearinfraclase: null,
                isLoading: false,
                error: action.payload
            }
/*-----------------------------Orden-----------------------------------*/
        case ORDEN_LOADING:
            return {
                ... state,
                isLoading : true,
                orden: null,
                error: ''
            }
        case ORDEN_LOADED:
            return {
                ...state,
                isLoading : false,
                orden: action.payload,
                error: ''
            };
        case ORDEN_ERROR:
            return {
                ...state,
                error: action.payload,
                orden: null,
                isLoading : false,
            }
        case CREARORDEN_LOADING:
            return {
                ... state,
                isLoading : true,
                crearorden : null,
                error: ''
            }
        case CREARORDEN_LOADED:
            return {
                ... state,
                isLoading : false,
                crearorden: action.payload,
                error: ''
            };
        case CREARORDEN_ERROR:
            return {
                ...state,
                crearorden : null,
                isLoading : false,
                error: action.payload,
            }
        case EDITARORDEN_LOADING:
            return {
                ... state,
                isLoading : true,
                crearorden: null,
                error: ''
            }
        case EDITARORDEN_LOADED:
            return {
                ... state,
                isLoading : false,
                crearorden: action.payload,
                error: ''
            };
        case EDITARORDEN_ERROR:
            return {
                ...state,
                crearorden: null,
                isLoading : false,
                error: action.payload,
            }            
        case DELETEORDEN_LOADED:
            return { 
                ...state, 
                crearorden: action.payload,
                isLoading: false,
                error: ''
            }
        case DELETEORDEN_LOADING:
            return { 
                ...state, 
                crearorden: null,
                isLoading: true,
                error: ''
            }
        case DELETEORDEN_ERROR:
            return { 
                ...state, 
                crearorden: null,
                isLoading: false,
                error: action.payload
            }
/*-----------------------------Sub Orden-----------------------------------*/
        case SUBORDEN_LOADING:
            return {
                ... state,
                isLoading : true,
                suborden: null,
                error: ''
            }
        case SUBORDEN_LOADED:
            return {
                ...state,
                isLoading : false,
                suborden: action.payload,
                error: ''
            };
        case SUBORDEN_ERROR:
            return {
                ...state,
                isLoading : false,
                suborden: action.payload,
                error: action.payload,
            }
        case CREARSUBORDEN_LOADING:
            return {
                ... state,
                isLoading : true,
                crearsuborden : null,
                error: ''
            }
        case CREARSUBORDEN_LOADED:
            return {
                ... state,
                isLoading : false,
                crearsuborden: action.payload,
                error: ''
            };
        case CREARSUBORDEN_ERROR:
            return {
                ...state,
                crearsuborden : null,
                isLoading : false,
                error: action.payload,
            }
        case EDITARSUBORDEN_LOADING:
            return {
                ... state,
                isLoading : true,
                crearsuborden: null,
                error: ''
            }
        case EDITARSUBORDEN_LOADED:
            return {
                ... state,
                isLoading : false,
                crearsuborden: action.payload,
                error: ''
            };
        case EDITARSUBORDEN_ERROR:
            return {
                ...state,
                crearsuborden: null,
                isLoading : false,
                error: action.payload,
            }            
        case DELETESUBORDEN_LOADED:
            return { 
                ...state, 
                crearsuborden: action.payload,
                isLoading: false,
                error: ''
            }
        case DELETESUBORDEN_LOADING:
            return { 
                ...state, 
                crearsuborden: null,
                isLoading: true,
                error: ''
            }
        case DELETESUBORDEN_ERROR:
            return { 
                ...state, 
                crearsuborden: null,
                isLoading: false,
                error: action.payload
            }
/*-----------------------------Familia-----------------------------------*/
        case FAMILIA_LOADING:
            return {
                ... state,
                isLoading : true,
                familia: null,
                error: ''
            }
        case FAMILIA_LOADED:
            return {
                ...state,
                isLoading : false,
                familia: action.payload,
                error: ''
            };
        case FAMILIA_ERROR:
            return {
                ...state,
                isLoading : false,
                familia: null,
                error: action.payload,
            }
        case CREARFAMILIA_LOADING:
            return {
                ... state,
                isLoading : true,
                crearfamilia : null,
                error: ''
            }
        case CREARFAMILIA_LOADED:
            return {
                ... state,
                isLoading : false,
                crearfamilia: action.payload,
                error: ''
            };
        case CREARFAMILIA_ERROR:
            return {
                ...state,
                crearfamilia : null,
                isLoading : false,
                error: action.payload,
            }
        case EDITARFAMILIA_LOADING:
            return {
                ... state,
                isLoading : true,
                crearfamilia: null,
                error: ''
            }
        case EDITARFAMILIA_LOADED:
            return {
                ... state,
                isLoading : false,
                crearfamilia: action.payload,
                error: ''
            };
        case EDITARFAMILIA_ERROR:
            return {
                ...state,
                crearfamilia: null,
                isLoading : false,
                error: action.payload,
            }            
        case DELETEFAMILIA_LOADED:
            return { 
                ...state, 
                crearfamilia: action.payload,
                isLoading: false,
                error: ''
            }
        case DELETEFAMILIA_LOADING:
            return { 
                ...state, 
                crearfamilia: null,
                isLoading: true,
                error: ''
            }
        case DELETEFAMILIA_ERROR:
            return { 
                ...state, 
                crearfamilia: null,
                isLoading: false,
                error: action.payload
            }
/*-----------------------------Sub Familia-----------------------------------*/
        case SUBFAMILIA_LOADING:
            return {
                ... state,
                isLoading : true,
                subfamilia: null,
                error: ''
            }
        case SUBFAMILIA_LOADED:
            return {
                ...state,
                isLoading : false,
                subfamilia: action.payload,
                error: ''
            };
        case SUBFAMILIA_ERROR:
            return {
                ...state,
                isLoading : false,
                subfamilia: null,
                error: action.payload,
            }
        case CREARSUBFAMILIA_LOADING:
            return {
                ... state,
                isLoading : true,
                crearsubfamilia : null,
                error: ''
            }
        case CREARSUBFAMILIA_LOADED:
            return {
                ... state,
                isLoading : false,
                crearsubfamilia: action.payload,
                error: ''
            };
        case CREARSUBFAMILIA_ERROR:
            return {
                ...state,
                crearsubfamilia : null,
                isLoading : false,
                error: action.payload,
            }
        case EDITARSUBFAMILIA_LOADING:
            return {
                ... state,
                isLoading : true,
                crearsubfamilia: null,
                error: ''
            }
        case EDITARSUBFAMILIA_LOADED:
            return {
                ... state,
                isLoading : false,
                crearsubfamilia: action.payload,
                error: ''
            };
        case EDITARSUBFAMILIA_ERROR:
            return {
                ...state,
                crearsubfamilia: null,
                isLoading : false,
                error: action.payload,
            }            
        case DELETESUBFAMILIA_LOADED:
            return { 
                ...state, 
                crearsubfamilia: action.payload,
                isLoading: false,
                error: ''
            }
        case DELETESUBFAMILIA_LOADING:
            return { 
                ...state, 
                crearsubfamilia: null,
                isLoading: true,
                error: ''
            }
        case DELETESUBFAMILIA_ERROR:
            return { 
                ...state, 
                crearsubfamilia: null,
                isLoading: false,
                error: action.payload
            }
/*-----------------------------Tribu-----------------------------------*/
        case TRIBU_LOADING:
            return {
                ... state,
                isLoading : true,
                tribu: null,
                error: ''
            }
        case TRIBU_LOADED:
            return {
                ...state,
                isLoading : false,
                tribu: action.payload,
                error: ''
            };
        case TRIBU_ERROR:
            return {
                ...state,
                isLoading : false,
                tribu: null,
                error: action.payload,
            }
        case CREARTRIBU_LOADING:
            return {
                ... state,
                isLoading : true,
                creartribu : null,
                error: ''
            }
        case CREARTRIBU_LOADED:
            return {
                ... state,
                isLoading : false,
                creartribu: action.payload,
                error: ''
            };
        case CREARTRIBU_ERROR:
            return {
                ...state,
                creartribu : null,
                isLoading : false,
                error: action.payload,
            }
        case EDITARTRIBU_LOADING:
            return {
                ... state,
                isLoading : true,
                creartribu: null,
                error: ''
            }
        case EDITARTRIBU_LOADED:
            return {
                ... state,
                isLoading : false,
                creartribu: action.payload,
                error: ''
            };
        case EDITARTRIBU_ERROR:
            return {
                ...state,
                creartribu: null,
                isLoading : false,
                error: action.payload,
            }            
        case DELETETRIBU_LOADED:
            return { 
                ...state, 
                creartribu: action.payload,
                isLoading: false,
                error: ''
            }
        case DELETETRIBU_LOADING:
            return { 
                ...state, 
                creartribu: null,
                isLoading: true,
                error: ''
            }
        case DELETETRIBU_ERROR:
            return { 
                ...state, 
                creartribu: null,
                isLoading: false,
                error: action.payload
            }
/*-----------------------------Genero-----------------------------------*/
        case GENERO_LOADING:
            return {
                ... state,
                isLoading : true,
                genero: null,
                error: ''
            }
        case GENERO_LOADED:
            return {
                ...state,
                isLoading : false,
                genero: action.payload,
                error: ''
            };
        case GENERO_ERROR:
            return {
                ...state,
                isLoading : false,
                genero: null,
                error: action.payload,
            }
        case CREARGENERO_LOADING:
            return {
                ... state,
                isLoading : true,
                creargenero : null,
                error: ''
            }
        case CREARGENERO_LOADED:
            return {
                ... state,
                isLoading : false,
                creargenero: action.payload,
                error: ''
            };
        case CREARGENERO_ERROR:
            return {
                ...state,
                creargenero : null,
                isLoading : false,
                error: action.payload,
            }
        case EDITARGENERO_LOADING:
            return {
                ... state,
                isLoading : true,
                creargenero: null,
                error: ''
            }
        case EDITARGENERO_LOADED:
            return {
                ... state,
                isLoading : false,
                creargenero: action.payload,
                error: ''
            };
        case EDITARGENERO_ERROR:
            return {
                ...state,
                creargenero: null,
                isLoading : false,
                error: action.payload,
            }            
        case DELETEGENERO_LOADED:
            return { 
                ...state, 
                creargenero: action.payload,
                isLoading: false,
                error: ''
            }
        case DELETEGENERO_LOADING:
            return { 
                ...state, 
                creargenero: null,
                isLoading: true,
                error: ''
            }
        case DELETEGENERO_ERROR:
            return { 
                ...state, 
                creargenero: null,
                isLoading: false,
                error: action.payload
            }
/*-----------------------------Especie-----------------------------------*/
        case ESPECIE_LOADING:
            return {
                ... state,
                isLoading: true,
                especie: null,
                error: ''
            }
        case ESPECIE_LOADED:
            return {
                ...state,
                isLoading: false,
                especie: action.payload,
                error: ''
            };
        case ESPECIE_ERROR:
            return {
                ...state,
                isLoading: false,
                especie: null,
                error: action.payload,
            }
        case CREARESPECIE_LOADING:
            return {
                ... state,
                isLoading : true,
                crearespecie : null,
                error: ''
            }
        case CREARESPECIE_LOADED:
            return {
                ... state,
                isLoading : false,
                crearespecie: action.payload,
                error: ''
            };
        case CREARESPECIE_ERROR:
            return {
                ...state,
                crearespecie : null,
                isLoading : false,
                error: action.payload,
            }
        case EDITARESPECIE_LOADING:
            return {
                ... state,
                isLoading : true,
                crearespecie: null,
                error: ''
            }
        case EDITARESPECIE_LOADED:
            return {
                ... state,
                isLoading : false,
                crearespecie: action.payload,
                error: ''
            };
        case EDITARESPECIE_ERROR:
            return {
                ...state,
                crearespecie: null,
                isLoading : false,
                error: action.payload,
            }            
        case DELETESPECIE_LOADED:
            return { 
                ...state, 
                crearespecie: action.payload,
                isLoading: false,
                error: ''
            }
        case DELETESPECIE_LOADING:
            return { 
                ...state, 
                crearespecie: null,
                isLoading: true,
                error: ''
            }
        case DELETESPECIE_ERROR:
            return { 
                ...state, 
                crearespecie: null,
                isLoading: false,
                error: action.payload
            }
        default: return state;
    }
}